import { styled } from '@mui/material/styles';

export const StyledDraggedContainer = styled<any>('div')(({ theme, isDraggingOver, marginLeft }) => {
    return {
        backgroundColor: isDraggingOver ? theme.palette.action.focus : theme.palette.background.paper,
    }
});

